// [2026-09-09 사용자] 설치사례 상세 본문 — 손으로 큐레이션(수기 블로그체 → 간결·스펙 설명형).
//   원본=네이버 블로그(evstech) 설치·AS 사례를 EVS가 정리. 헤딩+아이콘+간결 문단+시설 사양+이미지(썸네일→라이트박스).
//   ★자동생성 아님(gen_cases_ts.py 재실행 금지). 사실 근거=원문 실측(위치·시설·조치). 렌더=CaseDetail(applications식).
export interface CaseSection { title: string; icon: string; paras: string[]; specs: string[]; images: string[]; }
const I = (slug: string, n: number) => `/images/cases/${slug}/img_${String(n).padStart(2, '0')}.jpg`;

export const CASE_CONTENT: Record<string, CaseSection[]> = {
  // ── 안전(체감온도계) ──────────────────────────────────────────
  'bigcorp-install-review': [
    { title: '대기업이 선택한 안전관리 솔루션', icon: 'solution',
      paras: ['국내 대표 글로벌 그룹 계열사이자 단체급식·식음 서비스 1위 기업 「S사」 사업장에 EVS AI 온열질환 IoT 체감온도계를 도입했습니다.', '협력업체·근로자 안전을 위한 대기업의 엄격한 기준을 통과해 도입되었다는 점에서 제품의 신뢰성과 효과를 입증한 사례입니다.'],
      specs: [], images: [I('bigcorp-install-review', 2)] },
    { title: "단순 온도가 아닌 '체감온도' 기반 관리", icon: 'monitor',
      paras: ['체감 더위는 기온만으로 결정되지 않습니다. 체감온도계는 기온과 습도를 함께 측정해 근로자가 실제로 느끼는 체감온도(WBGT)를 정밀하게 산출합니다.', '습도까지 반영한 AI 알고리즘으로 일반 온도계가 놓치는 현장의 실제 위험도를 정확히 판단합니다.'],
      specs: [], images: [I('bigcorp-install-review', 3)] },
    { title: "'정상·주의·경고·위험' 단계별 직관 알림", icon: 'certified',
      paras: ['체감온도 기준으로 정상·주의·경고·위험 4단계를 분류하고, 단계별 화면 색상(정상=초록·위험=빨강)으로 멀리서도 위험을 한눈에 인지할 수 있습니다.', '각 단계에 맞는 권고 조치(수분 섭취·휴식 확대·작업 중지 등)를 화면에 자동 안내해 즉각적인 대응이 가능합니다.'],
      specs: [], images: [I('bigcorp-install-review', 4), I('bigcorp-install-review', 5)] },
    { title: 'IoT 기반 실시간 원격 모니터링', icon: 'signal',
      paras: ['설치된 단말은 인터넷에 연결되어, 안전관리자가 사무실에서도 스마트폰·PC로 각 작업장의 체감온도와 위험 단계를 실시간 확인할 수 있습니다.', '축적된 데이터는 향후 현장 안전관리 계획 수립의 근거로 활용됩니다.'],
      specs: [], images: [I('bigcorp-install-review', 6)] },
  ],
  'jamsil-site': [
    { title: '잠실 대형 건설현장 설치 개요', icon: 'monitor',
      paras: ['서울 잠실의 대형 인프라·건설 현장으로, 넓은 야외 부지와 다수 근로자가 직사광선·습도에 노출돼 체감온도가 급상승하기 쉬운 환경이었습니다.', 'H건설사는 강화된 산업안전보건법에 선제 대응하고 근로자 안전을 최우선으로 보호하기 위해 EVS AI 온열질환 IoT 체감온도계를 도입했습니다.'],
      specs: [], images: [I('jamsil-site', 2)] },
    { title: '고정밀 센서 기반 실시간 체감온도 산출', icon: 'gauge',
      paras: ['기상청 공식 체감온도 산출식을 적용해 온도와 습도를 복합 분석, 근로자가 느끼는 실제 위험도를 ±0.5℃ 정밀도로 1분 주기 실시간 수집합니다.'],
      specs: [], images: [I('jamsil-site', 3), I('jamsil-site', 4), I('jamsil-site', 7)] },
    { title: '위험 발생 시 1분 이내 다중 알림 전파', icon: 'signal',
      paras: ['체감온도 33℃ 이상 등 위험 단계 도달 시 대시보드 팝업·앱 푸시·SMS·카카오 알림 등 다중 채널로 현장 관리자와 안전 담당자에게 1분 이내 경보를 전파합니다.'],
      specs: [], images: [I('jamsil-site', 8)] },
    { title: 'AI 날씨 예측 기반 선제적 작업 관리', icon: 'monitor',
      paras: ['현재 측정에 그치지 않고 AI 날씨 예측으로 향후 폭염 가능성을 미리 파악해, 휴식 배정·작업 일정을 선제적으로 조정할 수 있도록 지원합니다.'],
      specs: [], images: [I('jamsil-site', 9)] },
    { title: '압도적 통신 안정성 (유선·WiFi·LTE)', icon: 'signal',
      paras: ['통신이 불안정한 건설 현장 특성에 대응해 유선·WiFi·LTE 멀티 통신을 지원하며, 98% 이상 업계 최고 수준의 통신 안정성을 확보합니다.'],
      specs: [], images: [I('jamsil-site', 10)] },
    { title: '자동 법적 증빙 기록 보존 (감사 로그)', icon: 'certified',
      paras: ['발생·조치·결과 이력이 자동 저장되어 고용노동부 제출용 데이터로 활용되며, 수기 기록의 오류·누락 리스크를 제거합니다.'],
      specs: [], images: [I('jamsil-site', 11)] },
    { title: '설치 후 기대효과', icon: 'certified',
      paras: ['휴식 기준(33℃) 즉시 감지로 폭염 사고를 미연에 방지하고, 수기 측정·기록에 들던 월 평균 45시간을 절감합니다.', '중대재해처벌법·산업안전보건법 기준을 준수하며 100% 자동 기록화로 법적 리스크를 최소화합니다.'],
      specs: [], images: [] },
  ],

  // ── 환경(대기배출 IoT) — 설치 사례 ────────────────────────────
  'env-filter-adsorb2': [
    { title: '사업장 개요', icon: 'building',
      paras: ['충청북도 증평군에 위치한 소규모 4·5종 대기배출 사업장으로, 여과집진시설과 흡착에 의한 시설 2대를 운영합니다. 탈사시설은 전력을 동력으로 사용하지 않아 전류계가 면제되었습니다.'],
      specs: ['여과집진시설 600㎥/분', '흡착에의한시설 1200㎥/분', '탈사시설(전류계 면제)', '도장시설 840㎥'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['방지시설 맞은편 벽면에 EVS가 자체 제조한 복수형 IoT 게이트웨이 EVS-G200D를 설치했습니다.'],
      specs: [], images: [I('env-filter-adsorb2', 2)] },
    { title: '송풍 전류계 설치', icon: 'energy',
      paras: ['각 방지시설 송풍기에 EVS 대표 DC 전류계(4–20mA)를 설치했습니다. 환경부 가이드 표준신호를 준수해 재설치 위험이 없습니다.'],
      specs: [], images: [I('env-filter-adsorb2', 4), I('env-filter-adsorb2', 5)] },
    { title: '온도계·차압계 설치 및 데이터 연동', icon: 'gauge',
      paras: ['시설 유입구에 온도계를, 벽면에 차압계를 고정 설치했습니다. 측정값과 실제값을 대조한 뒤 그린링크로 전송해 IoT 설치를 완료했습니다.'],
      specs: ['총 2대 방지시설 온도계·차압계'], images: [I('env-filter-adsorb2', 6), I('env-filter-adsorb2', 7), I('env-filter-adsorb2', 8), I('env-filter-adsorb2', 9), I('env-filter-adsorb2', 10)] },
  ],
  'env-filter-adsorb4': [
    { title: '사업장 개요', icon: 'building',
      paras: ['경기도 화성시에 위치한 사업장으로, 1차 여과·2차 흡착 시설 4대와 배출시설 8대(습식 도장시설 다수)를 운영합니다. IoT 측정기기를 설치한 사례입니다.'],
      specs: ['1·2차 여과+흡착 (50㎥/Min)', '도장시설[습식] 다수', '방지시설 4대 · 배출시설 8대'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['방지시설 맞은편 벽면에 EVS 자체 제조 복수형 IoT 게이트웨이 EVS-G200을 설치했습니다.'],
      specs: [], images: [I('env-filter-adsorb4', 2)] },
    { title: '송풍 전류계 설치', icon: 'energy',
      paras: ['4대 방지시설에 EVS 대표 DC 전류계(4–20mA)를 각각 설치했습니다. 환경부 가이드 표준신호를 준수합니다.'],
      specs: ['4대 방지시설 송풍 전류계'], images: [I('env-filter-adsorb4', 4)] },
    { title: '온도계·차압계 설치', icon: 'gauge',
      paras: ['시설 유입구에 온도계를, 벽면에 차압계를 고정 설치했습니다.'],
      specs: ['총 4대 방지시설 온도계·차압계'], images: [I('env-filter-adsorb4', 5), I('env-filter-adsorb4', 6)] },
    { title: '배출 전류계 설치 및 데이터 연동', icon: 'energy',
      paras: ['배출시설 8대에 배출 전류계를 각각 설치하고, 측정값 대조 후 그린링크 전송으로 IoT 설치를 완료했습니다.'],
      specs: ['배출시설 총 8대 배출 전류계'], images: [I('env-filter-adsorb4', 7), I('env-filter-adsorb4', 8), I('env-filter-adsorb4', 9)] },
  ],
  'env-filter1': [
    { title: '사업장 개요', icon: 'building',
      paras: ['충남 천안시에 위치한 동물용 사료·조례식품 제조업 사업장으로, 여과집진시설을 중심으로 저장·분쇄·성형·포장 시설을 갖췄습니다.'],
      specs: ['여과집진시설 (300㎥/min)', '고체입자상물질저장시설 25㎥×4·5㎥×2', '분쇄시설 75㎥', '성형시설 38.34kg/h', '포장시설 3.5T/h'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['여과집진시설 맞은편 벽면에 EVS 대표 IoT 게이트웨이 EVS-G200을 설치했습니다.'],
      specs: [], images: [I('env-filter1', 2)] },
    { title: '송풍 전류계 설치', icon: 'energy',
      paras: ['여과집진시설 송풍기에 EVS 대표 DC 전류계(4–20mA)를 설치했습니다. 환경부 가이드 표준신호를 준수해 재설치 위험이 없습니다.'],
      specs: [], images: [I('env-filter1', 4)] },
    { title: '온도계·차압계 설치', icon: 'gauge',
      paras: ['방지시설 유입구에 온도계를, 벽면에 차압계를 고정 설치했습니다.'],
      specs: [], images: [I('env-filter1', 5), I('env-filter1', 6)] },
    { title: '배출 전류계 설치 및 데이터 연동', icon: 'energy',
      paras: ['배출시설에 배출 전류계까지 설치하고, 측정값을 대조한 뒤 그린링크로 전송해 IoT 설치를 완료했습니다.'],
      specs: ['면제시설 제외 총 9대'], images: [I('env-filter1', 7), I('env-filter1', 8), I('env-filter1', 9), I('env-filter1', 10), I('env-filter1', 11), I('env-filter1', 12), I('env-filter1', 13), I('env-filter1', 14)] },
  ],
  'env-filter2': [
    { title: '사업장 개요', icon: 'building',
      paras: ['충남 예산군에 위치한 소규모 사업장으로, 여과집진시설 2대와 분쇄 배출시설 2대를 운영합니다. IoT 측정기기를 설치한 사례입니다.'],
      specs: ['여과집진시설 (60㎥/min)·(40㎥/min)', '분쇄시설 7.5kW·15kW'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['여과집진시설 맞은편 벽면에 EVS 자체 제조 복수형 IoT 게이트웨이 EVS-G200D를 설치했습니다.'],
      specs: [], images: [I('env-filter2', 2)] },
    { title: '송풍 전류계 설치', icon: 'energy',
      paras: ['각 방지시설에 EVS 대표 DC 전류계(4–20mA)를 설치했습니다. 환경부 가이드 표준신호를 준수합니다.'],
      specs: [], images: [I('env-filter2', 4), I('env-filter2', 5), I('env-filter2', 6)] },
    { title: '온도계·차압계 설치', icon: 'gauge',
      paras: ['각 여과집진시설 유입구에 온도계를, 벽면에 차압계를 설치했습니다.'],
      specs: [], images: [I('env-filter2', 7), I('env-filter2', 8), I('env-filter2', 9), I('env-filter2', 10)] },
    { title: '배출 전류계 설치 및 데이터 연동', icon: 'energy',
      paras: ['분쇄 배출시설 2대에 배출 전류계를 설치하고, 측정값 대조 후 그린링크 전송으로 IoT 설치를 완료했습니다.'],
      specs: [], images: [I('env-filter2', 11), I('env-filter2', 12), I('env-filter2', 13)] },
  ],
  'env-filter3': [
    { title: '사업장 개요', icon: 'building',
      paras: ['충남 천안시 동남구의 레미콘 제조업 사업장으로, 여과집진시설 3대와 배출시설 4대(혼합·계량 시설 포함)를 운영합니다. IoT 측정기기를 설치한 사례입니다.'],
      specs: ['여과집진시설 100㎥·40㎥·50㎥', '혼합시설 4㎥', '입자상물질계량시설(시멘트·슬래그·플라이애쉬)'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['방지시설 맞은편 벽면에 EVS 자체 제조 복수형 IoT 게이트웨이 EVS-G200D를 설치했습니다.'],
      specs: [], images: [I('env-filter3', 2)] },
    { title: '송풍 전류계 설치', icon: 'energy',
      paras: ['각 방지시설에 EVS 대표 DC 전류계(4–20mA)를 설치했습니다. 환경부 가이드 표준신호를 준수합니다.'],
      specs: [], images: [I('env-filter3', 4), I('env-filter3', 5)] },
    { title: '온도계·차압계 설치', icon: 'gauge',
      paras: ['각 방지시설 유입구에 온도계를, 벽면에 차압계를 고정 설치했습니다.'],
      specs: [], images: [I('env-filter3', 6), I('env-filter3', 7), I('env-filter3', 8), I('env-filter3', 9)] },
    { title: '배출 전류계 설치 및 데이터 연동', icon: 'energy',
      paras: ['배출시설마다 배출 전류계를 설치(총 4대)하고, 측정값 대조 후 그린링크 전송으로 IoT 설치를 완료했습니다.'],
      specs: ['배출 전류계 총 4대'], images: [I('env-filter3', 10), I('env-filter3', 11), I('env-filter3', 12), I('env-filter3', 13), I('env-filter3', 14)] },
  ],
  'env-cyclone1': [
    { title: '사업장 개요', icon: 'building',
      paras: ['원심력집진시설 1대와 제재시설 4대를 운영하는 목재 가공 사업장에 IoT 측정기기를 설치한 사례입니다. 전류계 일부는 통합 전원(차단기) 구성으로 면제되었습니다.'],
      specs: ['원심력집진시설 (350㎥/min)', '제재시설 24.75·17.25·4.125·31.57kW'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['원심력집진시설 맞은편 벽면에 EVS 대표 단수형 IoT 게이트웨이를 설치했습니다.'],
      specs: [], images: [I('env-cyclone1', 2)] },
    { title: '송풍 전류계 설치', icon: 'energy',
      paras: ['원심력집진시설에 필요한 송풍 전류계로 EVS 대표 DC 전류계(4–20mA)를 설치했습니다. 환경부 가이드 표준신호를 준수합니다.'],
      specs: [], images: [I('env-cyclone1', 3)] },
    { title: '배출 전류계 설치 및 데이터 연동', icon: 'energy',
      paras: ['제재 배출시설 4대에 배출 전류계를 각각 설치하고, 측정값 대조 후 그린링크 전송으로 IoT 설치를 완료했습니다.'],
      specs: ['제재시설 4대 배출 전류계'], images: [I('env-cyclone1', 4), I('env-cyclone1', 5), I('env-cyclone1', 6), I('env-cyclone1', 7), I('env-cyclone1', 8)] },
  ],
  'env-cyclone-scrub': [
    { title: '사업장 개요', icon: 'building',
      paras: ['충남 금산군에 위치한 사업장으로, 1차 원심력집진·2차 세정식집진 시설과 분쇄 배출시설 2대를 운영합니다.'],
      specs: ['1차 원심력집진시설 (60㎥/min)', '2차 세정식집진시설 (60㎥/min)', '분쇄시설 100HP·50HP'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['원심력·세정식집진시설 맞은편 벽면에 EVS 자체 제조 IoT 게이트웨이 EVS-G200을 설치했습니다.'],
      specs: [], images: [I('env-cyclone-scrub', 2)] },
    { title: '송풍 전류계·방지 순환펌프 설치', icon: 'energy',
      paras: ['방지시설 송풍 전류계와 세정집진시설 순환펌프계를 각각 설치했습니다. EVS 대표 DC 전류계(4–20mA)로 환경부 가이드 표준신호를 준수합니다.'],
      specs: [], images: [I('env-cyclone-scrub', 4), I('env-cyclone-scrub', 5)] },
    { title: '배출 전류계 설치 및 데이터 연동', icon: 'energy',
      paras: ['분쇄 배출시설 2대에 배출 전류계를 설치하고, 측정값 대조 후 그린링크 전송으로 IoT 설치를 완료했습니다.'],
      specs: [], images: [I('env-cyclone-scrub', 6), I('env-cyclone-scrub', 7), I('env-cyclone-scrub', 8)] },
  ],
  'env-absorb2': [
    { title: '사업장 개요', icon: 'building',
      paras: ['경기도 화성시의 전자집적회로 제조업 사업장으로, 흡수에 의한 시설 2대와 연마 배출시설을 운영합니다. 24시간 상시 가동 방지시설과 연결된 일부 배출시설은 전류계가 면제되었습니다.'],
      specs: ['흡수에의한시설 (55㎥/min)×2', '연마시설 60kW', '화학약품공급장치'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['흡수에 의한 시설 맞은편 벽면에 EVS 자체 제조 복수형 IoT 게이트웨이 EVS-G200D를 설치했습니다.'],
      specs: [], images: [I('env-absorb2', 2)] },
    { title: '송풍 전류계 설치', icon: 'energy',
      paras: ['각 방지시설에 방지 송풍 전류계를 설치했습니다. EVS 대표 DC 전류계(4–20mA)로 환경부 가이드 표준신호를 준수합니다.'],
      specs: [], images: [I('env-absorb2', 4), I('env-absorb2', 5)] },
    { title: '방지 순환펌프 설치', icon: 'droplet',
      paras: ['흡수 시설에 필요한 순환펌프 전류계를 각 방지시설에 설치했습니다. 순환펌프는 겨울철 배관 내 물을 순환시켜 동파를 방지하는 역할을 합니다.'],
      specs: [], images: [I('env-absorb2', 6), I('env-absorb2', 7), I('env-absorb2', 8), I('env-absorb2', 9)] },
    { title: 'pH계 설치 및 데이터 연동', icon: 'gauge',
      paras: ['각 시설에 pH계까지 설치하고, 측정값을 대조한 뒤 그린링크로 전송해 IoT 설치를 완료했습니다.'],
      specs: [], images: [I('env-absorb2', 10), I('env-absorb2', 11), I('env-absorb2', 12)] },
  ],
  'env-adsorb1': [
    { title: '사업장 개요', icon: 'building',
      paras: ['경기도 파주시에 위치한 목재 가구 제조업 사업장으로, 흡착에 의한 시설과 도장시설을 운영합니다. 전력을 사용하지 않는 배출시설은 전류계가 면제되었습니다.'],
      specs: ['흡착에의한시설 (250㎥/min)', '도장시설 (90㎥)'], images: [] },
    { title: '게이트웨이 설치', icon: 'gateway',
      paras: ['흡착에 의한 시설 맞은편 벽면에 EVS 대표 IoT 게이트웨이 EVS-G200을 설치했습니다.'],
      specs: [], images: [I('env-adsorb1', 2)] },
    { title: '송풍 전류계 설치', icon: 'energy',
      paras: ['흡착 시설에 필요한 송풍 전류계로 EVS 대표 DC 전류계(4–20mA)를 설치했습니다. 환경부 가이드 표준신호를 준수합니다.'],
      specs: [], images: [I('env-adsorb1', 4)] },
    { title: '온도계·차압계 설치 및 데이터 연동', icon: 'gauge',
      paras: ['방지시설 유입구에 온도계를, 옆 벽면에 차압계를 고정 설치했습니다. 측정값 대조 후 그린링크 전송으로 IoT 설치를 완료했습니다.'],
      specs: [], images: [I('env-adsorb1', 5), I('env-adsorb1', 6), I('env-adsorb1', 7)] },
  ],

  // ── 환경(대기배출 IoT) — A/S(사후관리) 사례 ────────────────────
  'env-as-internet': [
    { title: '문제 진단', icon: 'signal',
      paras: ['IoT 게이트웨이 인터넷 불량으로 데이터가 미전송되는 문제로 현장을 점검했습니다. 게이트웨이가 LAN 포트가 아닌 WAN 포트로 연결돼 시간 동기화가 되지 않은 것이 원인이었습니다.'],
      specs: [], images: [I('env-as-internet', 2)] },
    { title: '조치 완료', icon: 'certified',
      paras: ['포트를 정상 연결로 변경해 시간 동기화를 복구했습니다. 3선 전류계의 점퍼 미설정으로 전류값이 이상 출력되던 문제도 점퍼를 재설정해 정상화했습니다.', '전원 어댑터 이상으로 IR-400 LED가 점등되지 않던 문제는 어댑터 교체로 해결해 게이트웨이 정상 동작을 확인했습니다.'],
      specs: [], images: [I('env-as-internet', 3)] },
  ],
  'env-as-ph': [
    { title: '문제 진단', icon: 'gauge',
      paras: ['pH계 모듈러를 온도 보상용으로 교체해 달라는 요청으로 현장을 방문했습니다. 구형 모듈러 1개와 전원 이상이 있는 모듈러 1개의 교체가 필요한 상태였습니다.'],
      specs: [], images: [I('env-as-ph', 2)] },
    { title: '모듈러 교체·결선', icon: 'certified',
      paras: ['기존 pH계 모듈러를 제거하고 온도 보상용 모듈러로 교체했습니다. 탱크로리 깊이에 맞는 온도계를 결합해 모듈러 결선을 완료했습니다.', 'OUT-PUT 라인과 보드 연결 라인이 서로 바뀌어 있던 부분도 바로잡아 교체를 마무리했습니다.'],
      specs: [], images: [I('env-as-ph', 3), I('env-as-ph', 4)] },
  ],
  'env-as-power': [
    { title: '문제 진단', icon: 'energy',
      paras: ['현장 온열로 인한 전원 단절로 보드·컴퓨터 손상이 의심되는 문제로 방문했습니다. 발열 원인은 이미 제거된 상태여서 전원 단절 재현 테스트는 불가한 상황이었습니다.'],
      specs: [], images: [I('env-as-power', 2)] },
    { title: '조치 완료', icon: 'certified',
      paras: ['장비 우측에 냉각 팬을 설치하고 보드·컴퓨터를 교체해 전원 단절 문제를 해결했습니다. 이후 전원이 정상 공급되는 것을 확인했습니다.'],
      specs: [], images: [I('env-as-power', 3)] },
  ],
  'env-as-sensor': [
    { title: '문제 진단', icon: 'gauge',
      paras: ['차압계·전류계 오작동으로 현장을 점검했습니다. 우측 차압계가 -35의 비정상값을 표시하고 전류계가 오작동하는 상태였습니다.', '필터 슬러지가 많아 집진기 상부에 음압이 과하게 걸리면서 상·하부 차압이 800 이상으로 비정상 표기된 것이 원인이었습니다.'],
      specs: [], images: [I('env-as-sensor', 2)] },
    { title: '조치 완료', icon: 'certified',
      paras: ['차압계의 High·Low 배관을 바꿔 정상 범위(80~200)로 복구했습니다.'],
      specs: [], images: [] },
  ],
  'env-as-greenlink': [
    { title: '문제 진단', icon: 'signal',
      paras: ['차압센서 음수 표시와 DC 2선 전류계 2개의 그린링크 통신 끊김 문제로 현장을 점검했습니다.'],
      specs: [], images: [I('env-as-greenlink', 2)] },
    { title: '조치 완료', icon: 'certified',
      paras: ['차압계 High·Low 호스를 재연결해 음수 표시를 해결했습니다. 그린링크 통신이 되지 않던 DC 2선 전류계 2개는 교체 후 설정값을 변경해 통신을 정상화했습니다.'],
      specs: [], images: [I('env-as-greenlink', 3)] },
  ],
};
